import { render, staticRenderFns } from "./HuaYinArticle.vue?vue&type=template&id=2702cdcb&scoped=true&"
import script from "./HuaYinArticle.vue?vue&type=script&lang=js&"
export * from "./HuaYinArticle.vue?vue&type=script&lang=js&"
import style0 from "./HuaYinArticle.vue?vue&type=style&index=0&id=2702cdcb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2702cdcb",
  null
  
)

export default component.exports